import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGridTableView = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M16.5 6.5L1.5 6.5M11.5 16.5L11.5 1.5M16.5 11.5L1.5 11.5M6.5 16.5L6.5 1.5M6.83333 16.5H11.1667C13.0335 16.5 13.9669 16.5 14.68 16.1367C15.3072 15.8171 15.8171 15.3072 16.1367 14.68C16.5 13.9669 16.5 13.0335 16.5 11.1667V6.83333C16.5 4.96649 16.5 4.03307 16.1367 3.32003C15.8171 2.69282 15.3072 2.18289 14.68 1.86331C13.9669 1.5 13.0335 1.5 11.1667 1.5H6.83333C4.96649 1.5 4.03307 1.5 3.32003 1.86331C2.69282 2.18289 2.18289 2.69282 1.86331 3.32003C1.5 4.03307 1.5 4.96649 1.5 6.83333V11.1667C1.5 13.0335 1.5 13.9669 1.86331 14.68C2.18289 15.3072 2.69282 15.8171 3.32003 16.1367C4.03307 16.5 4.96649 16.5 6.83333 16.5Z",
		stroke: "#71717A",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgGridTableView);
export default ForwardRef;
